import LogMailTypes from 'store/actionTypes/logMail'
import UserTypes from 'store/actionTypes/user'

const initialData = {
  list: [],
  pagination: {},
  filter: {},
  modules: []
}

const logMail = (state = initialData, action = {}) => {
  const { payload } = action
  switch (action.type) {
    case LogMailTypes.GET_LOG_MAILS_SUCCESS:
      return {
        ...state,
        list: payload?.items,
        pagination: payload?.meta
      }
    case LogMailTypes.GET_LOG_MAILS_FAILED:
      return { ...state, current: payload }
    case LogMailTypes.UPDATE_FILTER_LOG_MAIL_SUCCESS:
      return { ...state, filter: payload }
    case LogMailTypes.CLEAR_FILTER_LOG_MAIL_SUCCESS:
      return { ...state, filter: initialData.filter }
    case UserTypes.LOGOUT_SUCCESS:
      return initialData
    default:
      return state
  }
}
export default logMail
